// components/EmbeddedStripeCheckout.jsx — Stripe Checkout intégré (iframe)
// Remplace la redirection vers une page Stripe hébergée (stripe.com) : le
// formulaire de paiement s'affiche directement dans notre page, via
// ui_mode:'embedded' côté backend (session.client_secret) + ce composant
// côté front. À la fin du paiement, Stripe redirige automatiquement la
// page (pas l'iframe) vers le `return_url` fourni au moment de la création
// de la session — aucun callback JS à câbler ici.
import { useMemo } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { EmbeddedCheckoutProvider, EmbeddedCheckout } from '@stripe/react-stripe-js';

// loadStripe() ne doit être appelé qu'une seule fois par clé publique (pas à
// chaque re-render/remount) — on met en cache la promesse au niveau module.
const stripePromiseCache = {};
function getStripePromise(publishableKey) {
  if (!stripePromiseCache[publishableKey]) {
    stripePromiseCache[publishableKey] = loadStripe(publishableKey);
  }
  return stripePromiseCache[publishableKey];
}

export default function EmbeddedStripeCheckout({ publishableKey, clientSecret }) {
  const stripePromise = useMemo(
    () => (publishableKey ? getStripePromise(publishableKey) : null),
    [publishableKey]
  );
  const options = useMemo(() => ({ clientSecret }), [clientSecret]);

  if (!publishableKey || !clientSecret) return null;

  return (
    <div style={{ borderRadius: 12, overflow: 'hidden', background: '#fff', minHeight: 420 }}>
      <EmbeddedCheckoutProvider stripe={stripePromise} options={options}>
        <EmbeddedCheckout />
      </EmbeddedCheckoutProvider>
    </div>
  );
}
